export function isJsonString(item: any) {
    item = typeof item !== 'string' ? JSON.stringify(item) : item

    try {
        item = JSON.parse(item)
    } catch (e) {
        return false
    }

    return typeof item === 'object' && item !== null
}

export function getMediaAttachmentType(url: string, source: string) {
    let media = 'image'

    if (
        source === 'instagram.com' &&
        !(
            url.includes('.png') ||
            url.includes('.gif') ||
            url.includes('.webp') ||
            url.includes('.jpg') ||
            url.includes('.jpeg')
        )
    ) {
        media = 'video'
    }

    return media
}

export const isFloat = (value: number) => {
    return !isNaN(value) && value % 1 !== 0
}
